/**
 * Єдиний бейдж стану документа (ч.641, рішення власника 2026-09-01):
 * БЕЗ галочок/іконок — кольоровий текст на м'якому фоні з рамкою
 * (еталон — бейдж «в процесі» редактора інвентаризації складу).
 * Рендериться в інфо-рядку DocumentToolbar (рядок назви сторінки).
 */

export type BadgeTone = 'green' | 'amber' | 'gray' | 'red' | 'blue';

// ч.963: тони — через CSS-змінні, щоб нічна тема перефарбовувала бейджі
// («не проведено» світив білим). Значення тем — у styles.css.
const TONES: Record<BadgeTone, { color: string; bg: string; border: string }> = {
  green: { color: 'var(--badge-green-fg)', bg: 'var(--badge-green-bg)', border: 'var(--badge-green-bd)' },
  amber: { color: 'var(--badge-amber-fg)', bg: 'var(--badge-amber-bg)', border: 'var(--badge-amber-bd)' },
  gray:  { color: 'var(--text-secondary)', bg: 'var(--bg-soft)', border: 'var(--border-strong)' },
  red:   { color: 'var(--badge-red-fg)', bg: 'var(--badge-red-bg)', border: 'var(--badge-red-bd)' },
  blue:  { color: 'var(--badge-blue-fg)', bg: 'var(--badge-blue-bg)', border: 'var(--badge-blue-bd)' },
};

export interface StatusBadge {
  label: string;
  tone: BadgeTone;
  title?: string;
}

export default function DocStatusBadge({ label, tone, title }: StatusBadge) {
  const t = TONES[tone];
  return (
    <span title={title} style={{
      color: t.color, background: t.bg, border: `1px solid ${t.border}`,
      borderRadius: 4, padding: '0 8px', fontSize: '0.85rem',
      fontWeight: 600, whiteSpace: 'nowrap', lineHeight: 1.6,
    }}>
      {label}
    </span>
  );
}
